import { styled } from "@mui/system";
import { emphasize } from "@mui/material/styles";
import Select from "react-select";
import { FormControl } from "@mui/material";

// Create individual styled components instead of useStyles object
export const FormControlRoot = styled("div")({
  zIndex: "auto",
  "& .MuiInputLabel-outlined": { width: "78%" },
  "& .MuiFormLabel-root": { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  "& .MuiInputBase-input": {
    display: "flex",
    alignItems: "center",
    paddingRight: "0",
    "& NO_COMPONENT_SELECTOR": {
      display: "inline-flex"
    }
  }
});

export const Input = styled("div")(({ disabled }) => ({
  display: "flex",
  padding: 0,
  minHeight: "56px",
  height: "auto",
  backgroundColor: disabled ? "rgba(242, 242, 242, 0.5)" : "transparent",
  "& > *": {
    minHeight: "56px"
  },
  "& + fieldset": {
    borderRadius: "8px ",
    border: "solid 1px rgba(194, 194, 194, 0.56)"
  }
}));

export const ValueContainer = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  flex: 1,
  alignItems: "center"
});

export const Chip = styled("div")(({ theme }) => ({
  margin: `${theme.spacing(0.5)} ${theme.spacing(0.25)}`
}));

export const ChipFocused = styled("div")(({ theme }) => ({
  backgroundColor: emphasize(
    theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[700],
    0.08
  )
}));

export const NoOptionsMessage = styled("div")(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`
}));

export const SingleValue = styled("div")({
  fontSize: 16
});

export const Placeholder = styled("div")({
  position: "absolute",
  left: 2,
  fontSize: 16
});

export const Divider = styled("div")(({ theme }) => ({
  height: theme.spacing(2)
}));

export const Indicator = styled("div")({
  width: "56px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  "& svg": {
    fontSize: "18px"
  }
});

export const IndicatorSeparator = styled("div")({
  width: 1,
  height: "100%",
  position: "absolute",
  top: 0,
  backgroundColor: "#ddd",
  left: 0
});

export const MenuItem = styled("div")({
  minHeight: 48,
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  whiteSpace: "normal",
  lineHeight: "normal",
  "& .MuiCheckbox-root": {
    marginLeft: "auto"
  }
});

export const StyledFormControl = styled(FormControl)({
  zIndex: "auto",
  width: "100%",
  display: "flex",
  position: "relative",
  "& > div": {
    margin: 0
  },
  "& .Mui-error": {
    "& .MuiFilledInput-input": {
      borderColor: "#ea2b1e"
    }
  },
  "& .selectFieldDescription": {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "12px",
    fontWeight: "400",
    color: "#757575",
    marginTop: "10px !important",
    alignItems: "center",
    whiteSpace: "pre-line",
    marginRight: "auto",
    gap: "8px",
    "& svg": {
      width: "14px",
      height: "14px",
      paddingRight: 0,
      paddingTop: 0
    },
    "& > div": {
      fontSize: "12px",
      minHeight: "unset",
      whiteSpace: "pre-line",
      fontWeight: 400
    }
  }
});

export const StyledSelectInput = styled(Select)(({ theme, isDisabled }) => ({
  "& .MuiInputLabel-filled": {
    color: isDisabled ? "#9B9CA0" : "#585A61",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "22px",
    letterSpacing: "0.08px"
  },
  "& .MuiInputLabel-shrink": {
    fontWeight: 500,
    fontSize: "0.875rem"
  },
  "& .MuiFilledInput-input": {
    fontSize: "1rem",
    textAlign: "left",
    display: "flex",
    padding: 0,
    minHeight: "56px",
    height: "auto",
    backgroundColor: isDisabled ? "#F2F2F2" : "#FFF",
    borderRadius: "10px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#BCBDC0",
    "& > *": {
      minHeight: "56px"
    },
    "& + fieldset": {
      borderRadius: "8px ",
      border: "solid 1px rgba(194, 194, 194, 0.56)"
    },
    "&.Mui-disabled": {
      fontSize: "1rem",
      background: "#F2F2F2",
      color: "#9B9CA0"
    },
    "&:focus-within": {
      borderColor: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
    }
  }
}));

// Keep the customStyles object as is for react-select
export const customStyles = {
  menu: provided => ({
    ...provided,
    zIndex: 9999,
    marginTop: "6px",
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "16px"
  }),
  menuList: (provided, state) => ({
    ...provided,
    paddingTop: state.selectProps?.name === "sourceOfIncome" ? "10px" : "4px",
    backgroundColor: "#ffffff",
    border: "solid 1px rgba(194, 194, 194, 0.56)",
    borderRadius: "8px"
  }),
  singleValue: (provided, state) => ({
    ...provided,
    whiteSpace: "nowrap",
    padding: "2px",
    marginTop: state.selectProps.labelText ? "6px" : "0px"
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#F5F5F5" : "#ffffff",
    color: "#1F1F1F",
    "&:hover": {
      backgroundColor: "#F5F5F5"
    }
  })
};
